import { IMeeting } from 'app/shared/model/meeting.model';

export interface IRecordedMeeting {
  id?: number;
  recordedMeetingId?: string | null;
  meeting?: IMeeting | null;
}

export const defaultValue: Readonly<IRecordedMeeting> = {};
